class LoadMoreProducts {
  constructor() {
    this.loadMoreBtn = document.getElementById("load-more-btn");
    this.productGrid = null;
    this.currentProductsCount = 0;
    this.isLoading = false;
    this.initialized = false;

    if (this.loadMoreBtn && !this.loadMoreBtn.dataset.initialized) {
      this.init();
    }
  }

  init() {
    // Prevent multiple initializations
    if (this.initialized || this.loadMoreBtn.dataset.initialized) {
      return;
    }

    this.productGrid = document.querySelector(
      `#product-grid-${this.loadMoreBtn.dataset.sectionId}`
    );
    this.currentProductsCount = parseInt(
      document.getElementById("current-products-count").textContent
    );

    // Remove any existing event listeners
    this.loadMoreBtn.removeEventListener("click", this.handleLoadMore);

    // Add event listener
    this.loadMoreBtn.addEventListener("click", this.handleLoadMore.bind(this));

    // Mark as initialized
    this.loadMoreBtn.dataset.initialized = "true";
    this.initialized = true;
  }

  async handleLoadMore(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isLoading) return;

    this.isLoading = true;
    this.toggleLoadingState(true);

    try {
      const nextPageUrl = this.loadMoreBtn.dataset.url;
      const sectionId = this.loadMoreBtn.dataset.sectionId;

      // Use Section Rendering API to fetch the next page
      const sectionUrl = `${nextPageUrl}&sections=${sectionId}`;
      const response = await fetch(sectionUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const sectionHtml = data[sectionId];

      // Parse the returned HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, "text/html");

      // Extract new products from the response
      const newProducts = doc.querySelectorAll(
        `#product-grid-${sectionId} .grid__item`
      );
      const newLoadMoreBtn = doc.getElementById("load-more-btn");

      // Append new products to existing grid
      newProducts.forEach((product) => {
        this.productGrid.appendChild(product);
      });

      // Update current products count
      this.currentProductsCount += newProducts.length;
      document.getElementById("current-products-count").textContent =
        this.currentProductsCount;

      // Update load more button or hide it if no more pages
      if (newLoadMoreBtn) {
        this.loadMoreBtn.dataset.url = newLoadMoreBtn.dataset.url;
        this.loadMoreBtn.dataset.currentPage =
          newLoadMoreBtn.dataset.currentPage;
      } else {
        // No more pages, hide the load more button
        this.loadMoreBtn.style.display = "none";
        const loadMoreInfo = document.querySelector(".load-more-info");
        if (loadMoreInfo) {
          loadMoreInfo.innerHTML = `Showing all ${this.currentProductsCount} products`;
        }
      }

      // Trigger any product card animations if they exist
      this.triggerProductAnimations();
    } catch (error) {
      console.error("Error loading more products:", error);
      this.showError("Failed to load more products. Please try again.");
    } finally {
      this.isLoading = false;
      this.toggleLoadingState(false);
    }
  }

  toggleLoadingState(loading) {
    const loadingSpinner = this.loadMoreBtn.querySelector(".loading-spinner");
    const loadMoreText = this.loadMoreBtn.querySelector(".load-more-text");

    if (loading) {
      loadingSpinner.style.display = "inline-block";
      loadMoreText.textContent = "Loading...";
      this.loadMoreBtn.disabled = true;
    } else {
      loadingSpinner.style.display = "none";
      loadMoreText.textContent = "Load More";
      this.loadMoreBtn.disabled = false;
    }
  }

  triggerProductAnimations() {
    // If your theme has product animations, trigger them here
    const newProducts = this.productGrid.querySelectorAll(
      ".grid__item:not(.animated)"
    );
    newProducts.forEach((product, index) => {
      setTimeout(() => {
        product.classList.add("animated");
        // Add any specific animation classes your theme uses
        if (this.productGrid.classList.contains("fadeInUp")) {
          product.style.animationDelay = `${index * 0.1}s`;
        }
      }, index * 100);
    });
  }

  showError(message) {
    // Remove any existing error messages first
    const existingError = document.querySelector(".load-more-error");
    if (existingError) {
      existingError.remove();
    }

    // Create a temporary error message
    const errorDiv = document.createElement("div");
    errorDiv.className = "load-more-error";
    errorDiv.style.cssText = `
      color: #d32f2f;
      text-align: center;
      margin-top: 10px;
      padding: 10px;
      background-color: #ffebee;
      border-radius: 4px;
      border: 1px solid #ffcdd2;
    `;
    errorDiv.textContent = message;

    this.loadMoreBtn.parentNode.insertBefore(
      errorDiv,
      this.loadMoreBtn.nextSibling
    );

    // Remove error message after 5 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.parentNode.removeChild(errorDiv);
      }
    }, 5000);
  }
}

// Prevent multiple initializations
let loadMoreInstance = null;

// Initialize when DOM is loaded
function initializeLoadMore() {
  if (!loadMoreInstance && document.getElementById("load-more-btn")) {
    loadMoreInstance = new LoadMoreProducts();
  }
}

// Initialize based on document state
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeLoadMore);
} else {
  initializeLoadMore();
}
